import log from 'salvo-lite/log'

class UpdateKlarna {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            event: 'click',
            ...JSON.parse(elem.getAttribute('data-update-klarna') || '{}')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        document.querySelector('.Popover__ValueList').addEventListener(this._data.event, async (e) => {
            setTimeout(() => {
                let chosenPrice = document.getElementById('product-price').innerHTML
                let instalment = parseFloat(chosenPrice.replace(/£/g, '')) / 3
                this._elem.innerHTML = '£' + parseFloat(instalment).toFixed(2)
            }, 1000)
        })
    }
}

export default UpdateKlarna



// WEBPACK FOOTER //
// ./src/resources/scripts/components/UpdateKlarna.js